export function withQuery(path, params) {
  if (!params) return path;
  const parts = [];
  for (const key of Object.keys(params)) {
    const value = params[key];
    if (value === null || value === undefined || value === false) continue;
    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(value)));
  }
  if (!parts.length) return path;
  return path + (path.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
}